import {Component, Inject, Input, OnInit} from '@angular/core';
import { ConstructionObjectNamePipe } from '@app/common/pipes/construction-object-name.pipe';
import { GeometricPlanRequestModel } from '@app/ps/models/geometric-plan-request.model';
import { GeometricPlanRequestTypeEnum, geometricPlanRequestTypeOptions } from '@app/ps/enums/geometric-plan-request-type.enum';
import { SelectItem } from '@app/common/components/select/select.component';
import { StateService } from '@uirouter/angular';
import { GeometricPlanRequestService } from '@app/ps/services/geometric-plan-request.service';
import { UploadFileExtended } from '@app/common/components/fileupload/fileupload.component';
import { OpinionRequestStatusEnum } from '@app/ps/enums/opinion-request-status.enum';
import { Restangular } from 'ngx-restangular';
import { approveOptions } from '@app/ps/enums/approve.enum';
import {SwitchOption} from '@app/common/components/switch/switch.component';
import { AreaModel } from '@app/common/models/area.model';
import { TitleModel } from '@app/common/models/title.model';
import { ParcelNumberPipe } from '@app/common/pipes/parcel-number.pipe';
import { TitleNamePipe } from '@app/common/pipes/title-name.pipe';
import { ProjectSubjectNamePipe } from '@app/ps/pipes/project-subject-name.pipe';
import { SupplierEditComponent } from '@app/ps/components/supplier-edit/supplier-edit.component';
import { ProjectSubjectModel } from '@app/ps/models/project-subject.model';
import * as _ from 'lodash';
import {DialogService} from '@app/common/services/dialog.service';
import {NoteTypeKeyEnum} from "@app/ps/enums/note-type-key.enum";
import {NoteTypeModel} from "@app/common/models/note-type.model";

@Component({
  selector: 'geometric-plan-request-create-from-prepared',
  templateUrl: './geometric-plan-request-create-from-prepared.component.html',
  styleUrls: ['./geometric-plan-request-create-from-prepared.component.scss']
})
export class GeometricPlanRequestCreateFromPreparedComponent implements OnInit {
  @Input() noteTypes: NoteTypeModel[];
  geometricPlanRequest = GeometricPlanRequestModel.create();
  typeOptions: SelectItem[] = geometricPlanRequestTypeOptions;
  approveOptions: SwitchOption[] = approveOptions;
  area: AreaModel;
  titles: TitleModel[];
  similarGeometricPlanRequestExists = false;
  type: SelectItem = this.typeOptions[0];
  typeEnum = GeometricPlanRequestTypeEnum;
  parcelSplitPreApproveByBuildingAuthority = this.approveOptions[0];
  parcelSplitPreApproveByBuildingAuthorityNote: string;
  parcelSplitPreApproveByOwner = this.approveOptions[0];
  parcelSplitPreApproveByOwnerNote: string;

  titleFilter = {
    validity: { values: ['valid'] },
    areaId: { values: [] },
  };

  parcelFilter = {
    validity: { values: ['valid'] },
    areaId: { values: [] },
    titleId: { values: [] },
  };

  constructionObjectFilter = {
    validity: { values: ['valid'] },
    areaId: { values: [] },
  };

  static readonly MSG_GP_FILES_DEFAULT = 'Vložte soubor přetažením nebo výběrem. Je možné vložit jeden soubor PDF.';
  static readonly MSG_GP_FILES_EXTENSION = 'Soubor musí být ve formátu PDF.';

  static readonly MSG_GP_VFK_FILES_DEFAULT = 'Vložte soubor přetažením nebo výběrem. Je možné vložit jeden soubor VFK.';
  static readonly MSG_GP_VFK_FILES_EXTENSION = 'Soubor musí být ve formátu VFK.';

  static readonly MSG_GP_DOC_FILES_DEFAULT = 'Vložte soubor přetažením nebo výběrem. Je možné vložit více souborů.';

  static readonly MSG_FILES_QUANTITY  = 'Je možné vložit pouze jeden soubor.';


  gpFiles: UploadFileExtended[] = [];
  gpVfkFiles: UploadFileExtended[] = [];
  gpDocFiles: UploadFileExtended[] = [];
  gpFilesValid = false;
  gpVfkFilesValid = false;
  gpFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_FILES_DEFAULT;
  gpVfkFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_VFK_FILES_DEFAULT;
  gpDocFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_DOC_FILES_DEFAULT;

  constructor(
    public requestService: GeometricPlanRequestService,
    public constructionObjectNamePipe: ConstructionObjectNamePipe,
    private stateService: StateService,
    private restangular: Restangular,
    public parcelNumberPipe: ParcelNumberPipe,
    public titleNamePipe: TitleNamePipe,
    public projectSubjectNamePipe: ProjectSubjectNamePipe,
    private dialogService: DialogService,
  ) {
    this.onSubmit = this.onSubmit.bind(this);
  }

  ngOnInit() {
  }

  isValid(): boolean {
    return !!(
      this.type
      && this.geometricPlanRequest.name
      && this.geometricPlanRequest.supplier
      && this.geometricPlanRequest.verificationDate
      && this.geometricPlanRequest.approvedDate
      && this.geometricPlanRequest.pgpNumber
      && this.area
      && this.geometricPlanRequest.parcels
      && this.geometricPlanRequest.parcels.length
      && (this.type.id !== GeometricPlanRequestTypeEnum.EASEMENT_EXTENT
        || (this.geometricPlanRequest.constructionObjects && !!this.geometricPlanRequest.constructionObjects.length)
      )
      && this.gpFilesValid
      && this.gpVfkFilesValid
    );
  }

  onCadastreChanged() {
    this.titleFilter.areaId.values = [this.area.id];
    this.parcelFilter.areaId.values = [this.area.id];
    this.constructionObjectFilter.areaId.values = [this.area.id];

    this.titles = undefined;
    this.geometricPlanRequest.parcels = undefined;
  }

  onTitleChanged() {
    this.parcelFilter.titleId.values = this.titles;
    this.geometricPlanRequest.parcels = undefined;
  }

  onParcelsChanged() {
    this.checkExistingSimilarOpinionRequest();
  }

  onGpFilesChange(files: UploadFileExtended[]) {
    this.gpFiles = files;

    const extensionValid = files.every(f => f.extension && f.extension.toLowerCase() === 'pdf');

    if (this.gpFiles.length === 0) {
      this.gpFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_FILES_DEFAULT;
    } else if (!extensionValid) {
      this.gpFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_FILES_EXTENSION;
    } else if (this.gpFiles.length > 1) {
      this.gpFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_FILES_QUANTITY;
    } else {
      this.gpFilesMsg = '';
    }

    this.gpFilesValid = (extensionValid && this.gpFiles.length === 1);
  }

  onGpVfkFilesChange(files: UploadFileExtended[]) {
    this.gpVfkFiles = files;

    const extensionValid = files.every(f => f.extension && f.extension.toLowerCase() === 'vfk');

    if (this.gpVfkFiles.length === 0) {
      this.gpVfkFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_VFK_FILES_DEFAULT;
    } else if (!extensionValid) {
      this.gpVfkFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_GP_VFK_FILES_EXTENSION;
    } else if (this.gpVfkFiles.length > 1) {
      this.gpVfkFilesMsg = GeometricPlanRequestCreateFromPreparedComponent.MSG_FILES_QUANTITY;
    } else {
      this.gpVfkFilesMsg = '';
    }

    this.gpVfkFilesValid = (extensionValid && this.gpVfkFiles.length === 1);
  }

  onGpDocFilesChange(files: UploadFileExtended[]) {
    this.gpDocFiles = files;
  }

  onUpdateSupplier() {
    const dialog = this.dialogService.open(SupplierEditComponent, {
      data: { supplierId: this.geometricPlanRequest.supplier.id }
    });

    const sub = dialog.afterClosed.subscribe((res: ProjectSubjectModel) => {
      if (res) {
        _.extend(this.geometricPlanRequest.supplier, res);
      }
      sub.unsubscribe();
    });
  }

  onCreateSupplier() {
    const dialog = this.dialogService.open(SupplierEditComponent, { data: {} });
    const sub = dialog.afterClosed.subscribe((res: ProjectSubjectModel) => {
      if (res) {
        this.geometricPlanRequest.supplier = res;
      }
      sub.unsubscribe();
    });
  }

  onSubmit(): Promise<any> {
    this.geometricPlanRequest.type = this.type.id as string;
    this.geometricPlanRequest.areas = this.area ? [this.area] : [];
    this.geometricPlanRequest.parcelSplitPreApproveByBuildingAuthority = this.parcelSplitPreApproveByBuildingAuthority.id as string;
    this.geometricPlanRequest.parcelSplitPreApproveByOwner = this.parcelSplitPreApproveByOwner.id as string;

    const notes = [];

    if (this.geometricPlanRequest.type === GeometricPlanRequestTypeEnum.PARCEL_SPLIT && this.parcelSplitPreApproveByBuildingAuthorityNote) {
      notes.push({
        text: this.parcelSplitPreApproveByBuildingAuthorityNote,
        noteType: this.noteTypes.find(nt => nt.key === NoteTypeKeyEnum.ParcelSplitPreApproveByBuildingAuthority)
      });
    }

    if (this.geometricPlanRequest.type === GeometricPlanRequestTypeEnum.PARCEL_SPLIT && this.parcelSplitPreApproveByOwnerNote) {
      notes.push({
        text: this.parcelSplitPreApproveByOwnerNote,
        noteType: this.noteTypes.find(nt => nt.key === NoteTypeKeyEnum.ParcelSplitPreApproveByOwner)
      });
    }

    return this.requestService
      .createFromPrepared(this.geometricPlanRequest, notes, this.gpFiles, this.gpVfkFiles, this.gpDocFiles)
      .then(geometricPlanRequest => {
        this.stateService.go(
          'symap.project.geometricPlanRequests.detail',
          { id: geometricPlanRequest.id, tab: 'parcels-budouc' });
      });
  }

  private checkExistingSimilarOpinionRequest() {
    if (!this.geometricPlanRequest.parcels || !this.geometricPlanRequest.parcels.length) {
      this.similarGeometricPlanRequestExists = false;
      return;
    }

    const parcelIds = this.geometricPlanRequest.parcels.map(p => p.id);
    const filter = { filter: { filters: { parcelId: parcelIds }}};

    this.restangular
      .all('geometric-plan-requests').customPOST(filter)
      .toPromise()
      .then(data => {
        const requests = data.plain().filter(or => or.status !== OpinionRequestStatusEnum.DELETED);
        this.similarGeometricPlanRequestExists = requests.length > 0;
      });
  }
}
